import { $,Backbone } from '../vendor'
import { Biscuit} from './utils';
// @ts-ignore
import * as env from '../../cypress.json'
import Inboomai18n from './utils/Inboomai18n';

// IE needs this explicitly (see POST /getPrice)
// adds { _ : new Date().milliseconds } to url
$.ajaxSetup({ cache: false });

/**
 * @file Sync.js
 * @author Felix Albroscheit
 * 
 * Appends API specific options to ajax calls (~ $.ajaxSetup())
 */

const sync: (method: string, model: (Backbone.Model | Backbone.Collection), options?: JQueryAjaxSettings) => any = Backbone.sync;

// Default app settings (e.g. API host, third-party keys)
export const Settings: {
    API_HOST: string;
    INVOICE_API_HOST: string;
    API_HOST_PUBLIC: string;
    API_HOST_STAGING: string;
    INVOICE_API_HOST_STAGING: string;
    API_HOST_STAGING_PUBLIC: string;
    API_HOST_TEST: string;
    INVOICE_API_HOST_TEST: string;
    API_HOST_TEST_PUBLIC: string;
    GOOGLE_MAPS_API_KEY: string;
    language: string
} = {
    API_HOST: 'https://api.inbooma.net/api',
    INVOICE_API_HOST: 'https://invoice.inbooma.net/api',
    API_HOST_PUBLIC: 'https://api.inbooma.net',
    API_HOST_STAGING: 'https://staging-api.inbooma.net/api',
    INVOICE_API_HOST_STAGING: 'https://staging-invoice.inbooma.net/api',
    API_HOST_STAGING_PUBLIC: 'https://staging-api.inbooma.net',
    API_HOST_TEST: 'https://test-api.inbooma.net/api',
    INVOICE_API_HOST_TEST: 'https://test-invoice.inbooma.net/api',
    API_HOST_TEST_PUBLIC: 'https://test-api.inbooma.net',
    GOOGLE_MAPS_API_KEY: 'AIzaSyA-KYu6ZYUf3ISccsHsweCIGMKNn0jrefY',
    language : Inboomai18n.getActiveLanguageCode(),
};

/**
 * @return {string}
 */
export function getApiHost (publicSet: boolean = false, invoice: boolean =false): string {
  
    let host: string = (publicSet?Settings.API_HOST_PUBLIC:invoice?Settings.INVOICE_API_HOST:Settings.API_HOST);

    if (document.location.host.toLowerCase().indexOf('test-web.inbooma.net') >= 0
        || document.location.host.toLowerCase().indexOf('localhost') >= 0) {
        host = (publicSet?Settings.API_HOST_TEST_PUBLIC:invoice?Settings.INVOICE_API_HOST_TEST:Settings.API_HOST_TEST);
    }

    if (document.location.host.toLowerCase().indexOf('staging-web.inbooma.net') >= 0
        || (document.location.host.toLowerCase().indexOf('localhost') >= 0)
        && document.location.host.toLowerCase().indexOf('staging') >= 0) {
        host = (publicSet?Settings.API_HOST_STAGING_PUBLIC:invoice?Settings.INVOICE_API_HOST_STAGING:Settings.API_HOST_STAGING);
    }

    // @ts-ignore    
    if (typeof env !== 'undefined' && typeof env.localApiUrl !== 'undefined' && !publicSet && !invoice) {
    // @ts-ignore    
        host = env.localApiUrl;
    }

    return host;
}

/**
 * @return {string}
 */
export function getEnv (forWebsocket: boolean = false): string {

    let envi: string = (forWebsocket?'live':'prod');

    if (document.location.host.toLowerCase().indexOf('test-web.inbooma.net') >= 0
        || document.location.host.toLowerCase().indexOf('localhost') >= 0) {
        envi = 'test';
    }

    if (document.location.host.toLowerCase().indexOf('staging-web.inbooma.net') >= 0
        || (document.location.host.toLowerCase().indexOf('localhost') >= 0)
        && document.location.host.toLowerCase().indexOf('staging') >= 0) {
        envi = 'staging';
    }

    return envi;
}

export const GlobalDebug: (debugOn: boolean, suppressAll: boolean) => void = (function (): (debugOn: boolean, suppressAll: boolean) => void {
    let savedConsole: Console = console;
    /**
     * @param {boolean} debugOn
     * @param {boolean} suppressAll
     */
    return function (debugOn: boolean, suppressAll: boolean): void {
        let suppress = suppressAll || false;
        if (!debugOn) {
            // supress the default console functionality
            //console = {};
            console.log = function () {};
            // supress all type of consoles
            if (suppress) {
                console.info = function () {};
                console.warn = function () {};
                console.error = function () {};
            } else {
                console.info = savedConsole.info;
                console.warn = savedConsole.warn;
                console.error = savedConsole.error;
            }
        } else {
            console = savedConsole;
        }
    };
})();

type HeadersType = {
    [key: string]: string;
}
export function getRequestHeaders (isV2: boolean = false, method: string = 'read') {

    let headers: HeadersType = {};

    if (isV2) {
        headers['Accept'] = 'application/vnd.api+json';
        headers['Content-Type'] = 'application/vnd.api+json';
    } else {
        headers['Accept'] = 'application/json';
        headers['Content-Type'] = 'application/json';
    }

    if (method !== 'read') {
        headers['Content-Language'] = Inboomai18n.getActiveLanguageCode();
    } else {
        headers['Accept-Language'] = Inboomai18n.getActiveLanguageCode();
    }

    headers['Authorization'] = `Bearer ${Biscuit.get('token')}`;

    return headers;
}

/**
 * @override Backbone.sync
 * 
 * Take care that param "model" can also be a collection!
 */
Backbone.sync = (method: string, model: any, options: any ): void => {

    const isV2 = false; //typeof model.isV2 !== 'undefined' && model.isV2;

    if (typeof model.url !== 'undefined'/* && model.url.search('file') == -1*/){

        options.url = getApiHost();

        if (!isV2) {
        
            if (typeof model.url == 'function') {
                options.url += model.url();
            } else {
                options.url += model.url;
            }

            if (options.url.indexOf('/orders') >= 0 && method === 'read' && options.url.indexOf('getRentalContract') == -1) {
                  options.url += '?find=full';
            }
        }
    }

    options.beforeSend = (xhr: any): void => {
        const headers = getRequestHeaders(isV2, method);
        Object.keys(headers).forEach((headerName: string): void => {
            xhr.setRequestHeader(headerName, headers[headerName]);
        });
    };

    if (typeof model.models !== 'undefined') {
        if (typeof model._pagination !== 'undefined' && typeof model.beforeSync === 'function') {
            model.beforeSync(method, options);
        }
    }

    sync.call(this, method, model, options);
};
